module.exports = __webpack_public_path__ + "img/confirm-password_icon.9fdcd605.svg";